// Theme Actions
export const SET_DARK_MODE = 'SET_DARK_MODE';

export const setDarkMode = (isDarkMode) => ({
  type: SET_DARK_MODE,
  payload: isDarkMode,
});
